export default __webpack_public_path__ + "static/media/sais-logo-2.911f0bfc.jpg";